module.exports = __webpack_public_path__ + "img/avatar0.12525fc9.png";